import { List } from '@cko/primitives';
import styled, { css } from 'styled-components';

import {
  levelOneContentStyle,
  levelOnePaddingStyle,
  menuItemHoverStyle,
} from '../SideNavMenu.styles';

type StyledAccordionBodyProps = {
  isOpen: boolean;
  bodyHeight: number;
};

export const StyledAccordionBody = styled(List)<StyledAccordionBodyProps>`
  border-left: var(--border-b-seed) solid var(--base-border-secondary);
  margin-left: var(--layout-soapbar);
  transition:
    max-height 220ms ease-out,
    opacity 100ms ease-out;

  ${({ isOpen, bodyHeight }) =>
    isOpen
      ? css`
          max-height: ${bodyHeight};
          opacity: 1;
          overflow: visible;
          margin-bottom: var(--layout-soapbar);
        `
      : css`
          max-height: 0px;
          opacity: 0;
          overflow: hidden;
        `};
`;

export const StyledMenuAccordionButton = styled.button`
  background: none;
  border: none;
  ${levelOnePaddingStyle}
  ${levelOneContentStyle}
  display: flex;
  align-items: center;
  cursor: pointer;

  ${menuItemHoverStyle}
`;
